import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TWorkloadDataResponse } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetWorkloadData = async ({
  dateMin,
  dateMax
}: {
  dateMin: Date;
  dateMax: Date;
}): Promise<{
  data: TWorkloadDataResponse;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TWorkloadDataResponse>(
    `auditor/getWorkloadData`,
    {
      dateMinObject: getDateAsObject(dateMin),
      dateMaxObject: getDateAsObject(dateMax)
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: { workload: [], totalWorkLoadByCSRs: [] },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: { workload: [], totalWorkLoadByCSRs: [] },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
